<div>
    <app-immigration-document-upload [primaryData]="primaryData" (formDetailsChange)="onFormDetailsChange($event)"></app-immigration-document-upload>
</div>
